import React, {
  ReactElement, useState,
} from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle, IconButton,
  Paper,
} from '@mui/material';
import {AccommodationReservationComment} from "../../../components/Comment/AccommodationReservationComment";
import {serviceReservationViewTable} from "../../../schema/serviceReservationViewTable";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import {ConfirmationTable} from "./ConfirmationTable";
import {DialogProps} from "@mui/material/Dialog";
import {CloseRounded} from "@mui/icons-material";
import {accommodationReservation} from "../../../schema/accommodationReservation";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(1),
  boxShadow: 'none',
}));

export const ChatDialog = ({
                              data,
                              onClose,
                            }: {
  data: any;
  onClose: () => void;
}): ReactElement => {

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('lg');

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={onClose}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        <DialogTitle>Chat - {data?.formatted?.group} / {`${data?.formatted?.arrival} - ${data?.formatted?.departure}`}</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme:any) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseRounded />
        </IconButton>

        <DialogContent dividers>

          <Box sx={{
            flexGrow: 1,
          }}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={4} lg={4}>
                <Item sx={{
                  background: '#f3f3f3',
                  border: '1px solid #dddddd'
                }}>
                  <Typography variant={"h6"}>
                    Foglalási adatok
                  </Typography>

                  <ConfirmationTable item={data} />
                  
                </Item>
              </Grid>

              <Grid item xs={12} md={8} lg={8}>
                <Item>

                  <AccommodationReservationComment
                    schema={accommodationReservation()}
                    values={data.formatted}
                    fullWidth={true}
                  />

                </Item>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
